export type CountryCallingCode = {
  name: string;
  iso2: string;
  dialCode: string;
};

/** Convertit un code ISO-3166 alpha-2 en emoji drapeau (indicateurs régionaux Unicode). */
export function isoToFlagEmoji(iso2: string): string {
  return iso2
    .toUpperCase()
    .replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt(0)));
}

/** Bénin en tête (pays cible de l'app), puis Afrique de l'Ouest/Centrale, puis reste du monde par ordre alphabétique. */
export const COUNTRY_CALLING_CODES: CountryCallingCode[] = [
  { name: "Bénin", iso2: "BJ", dialCode: "229" },
  { name: "Togo", iso2: "TG", dialCode: "228" },
  { name: "Ghana", iso2: "GH", dialCode: "233" },
  { name: "Nigeria", iso2: "NG", dialCode: "234" },
  { name: "Niger", iso2: "NE", dialCode: "227" },
  { name: "Burkina Faso", iso2: "BF", dialCode: "226" },
  { name: "Côte d'Ivoire", iso2: "CI", dialCode: "225" },
  { name: "Mali", iso2: "ML", dialCode: "223" },
  { name: "Sénégal", iso2: "SN", dialCode: "221" },
  { name: "Guinée", iso2: "GN", dialCode: "224" },
  { name: "Guinée-Bissau", iso2: "GW", dialCode: "245" },
  { name: "Gambie", iso2: "GM", dialCode: "220" },
  { name: "Sierra Leone", iso2: "SL", dialCode: "232" },
  { name: "Liberia", iso2: "LR", dialCode: "231" },
  { name: "Cap-Vert", iso2: "CV", dialCode: "238" },
  { name: "Mauritanie", iso2: "MR", dialCode: "222" },
  { name: "Cameroun", iso2: "CM", dialCode: "237" },
  { name: "Tchad", iso2: "TD", dialCode: "235" },
  { name: "Gabon", iso2: "GA", dialCode: "241" },
  { name: "Congo-Brazzaville", iso2: "CG", dialCode: "242" },
  { name: "Congo (RDC)", iso2: "CD", dialCode: "243" },
  { name: "République centrafricaine", iso2: "CF", dialCode: "236" },
  { name: "Guinée équatoriale", iso2: "GQ", dialCode: "240" },
  { name: "Algérie", iso2: "DZ", dialCode: "213" },
  { name: "Maroc", iso2: "MA", dialCode: "212" },
  { name: "Tunisie", iso2: "TN", dialCode: "216" },
  { name: "Libye", iso2: "LY", dialCode: "218" },
  { name: "Égypte", iso2: "EG", dialCode: "20" },
  { name: "Kenya", iso2: "KE", dialCode: "254" },
  { name: "Tanzanie", iso2: "TZ", dialCode: "255" },
  { name: "Ouganda", iso2: "UG", dialCode: "256" },
  { name: "Rwanda", iso2: "RW", dialCode: "250" },
  { name: "Burundi", iso2: "BI", dialCode: "257" },
  { name: "Éthiopie", iso2: "ET", dialCode: "251" },
  { name: "Afrique du Sud", iso2: "ZA", dialCode: "27" },
  { name: "Zambie", iso2: "ZM", dialCode: "260" },
  { name: "Zimbabwe", iso2: "ZW", dialCode: "263" },
  { name: "Mozambique", iso2: "MZ", dialCode: "258" },
  { name: "Angola", iso2: "AO", dialCode: "244" },
  { name: "Madagascar", iso2: "MG", dialCode: "261" },
  { name: "France", iso2: "FR", dialCode: "33" },
  { name: "Belgique", iso2: "BE", dialCode: "32" },
  { name: "Suisse", iso2: "CH", dialCode: "41" },
  { name: "Allemagne", iso2: "DE", dialCode: "49" },
  { name: "Royaume-Uni", iso2: "GB", dialCode: "44" },
  { name: "Espagne", iso2: "ES", dialCode: "34" },
  { name: "Italie", iso2: "IT", dialCode: "39" },
  { name: "Portugal", iso2: "PT", dialCode: "351" },
  { name: "Pays-Bas", iso2: "NL", dialCode: "31" },
  { name: "Canada", iso2: "CA", dialCode: "1" },
  { name: "États-Unis", iso2: "US", dialCode: "1" },
  { name: "Chine", iso2: "CN", dialCode: "86" },
  { name: "Inde", iso2: "IN", dialCode: "91" },
  { name: "Émirats arabes unis", iso2: "AE", dialCode: "971" },
  { name: "Arabie saoudite", iso2: "SA", dialCode: "966" },
  { name: "Liban", iso2: "LB", dialCode: "961" },
  { name: "Turquie", iso2: "TR", dialCode: "90" },
  { name: "Brésil", iso2: "BR", dialCode: "55" },
];
